export default __webpack_public_path__ + "static/media/Arimo-Bold.b2df0629.ttf";